export class FilterType {

    readonly LATEST_PLAN_FILING: number = 0;
    readonly PLAN_YEARS : number = 1;
    readonly DEFINED_BENEFIT : number = 2;
    readonly DEFINED_CONTRIBUTION : number = 3;
    readonly PENSION : number = 4;
    readonly WELFARE: number = 5;
    readonly ASSETS: number = 6;
    readonly PARTICIPANTS: number = 7;
    readonly EMPLOYER: number = 8;
    readonly BUSINESS: number = 9;
    readonly STATES: number = 10;
    readonly FOREIGN: number = 11;
    readonly FORM_YEARS: number = 12;
    readonly ZIPCODE: number = 13;
}